(function () {
  if (window.__sipitHomeInit) return;
  window.__sipitHomeInit = true;

  const roots = document.querySelectorAll('.sipit-home');
  if (!roots.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  function formatMoney(amount, format) {
    const value = Number.isFinite(amount) ? amount : 0;
    const cents = Math.round(value * 100);
    const withCents = (cents / 100).toFixed(2);
    if (!format || format.includes('{{')) {
      return '$' + withCents;
    }
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(value).toString())
      .replace(/\{\{\s*amount\s*\}\}/, withCents);
  }

  async function addToCart(variantId, sellingPlanId, mode, options = {}) {
    const payload = {
      items: [{ id: Number(variantId), quantity: 1 }],
    };

    if (mode === 'subscribe' && sellingPlanId) {
      payload.items[0].selling_plan = Number(sellingPlanId);
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not add to cart.');
    }

    if (options.redirectToCart) {
      window.location.href = '/cart';
      return;
    }

    const cartTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (cartTrigger) {
      cartTrigger.click();
    } else {
      window.location.href = '/cart';
    }
  }

  function initHeroShop(section) {
    if (!section || section.dataset.sipitHeroInit === '1') return;
    section.dataset.sipitHeroInit = '1';

    const moneyFormat = section.dataset.moneyFormat || '$';
    const pouches = section.querySelectorAll('[data-sipit-hero-pouch]');

    pouches.forEach((pouch) => {
      const shopBtn = pouch.querySelector('[data-sipit-pouch-onetime]');
      const subscribeBtn = pouch.querySelector('[data-sipit-pouch-subscribe]');
      const onetimePrice = pouch.querySelector('[data-sipit-pouch-onetime-price]');
      const subscribePrice = pouch.querySelector('[data-sipit-pouch-subscribe-price]');
      const errorEl = pouch.querySelector('[data-sipit-pouch-error]');

      const one = parseFloat(pouch.dataset.onetime || '0');
      const sub = parseFloat(pouch.dataset.subscribe || '0');
      if (onetimePrice) onetimePrice.textContent = formatMoney(one, moneyFormat);
      if (subscribePrice) subscribePrice.textContent = formatMoney(sub, moneyFormat);

      const handleClick = async (btn, mode) => {
        if (!btn) return;
        btn.disabled = true;
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        try {
          await addToCart(pouch.dataset.variantId, pouch.dataset.sellingPlan, mode);
        } catch (error) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = error.message || 'Could not add to cart.';
          }
        } finally {
          btn.disabled = false;
        }
      };

      if (shopBtn) shopBtn.addEventListener('click', () => handleClick(shopBtn, 'onetime'));
      if (subscribeBtn) subscribeBtn.addEventListener('click', () => handleClick(subscribeBtn, 'subscribe'));
    });

    const mobileShop = section.querySelector('[data-sipit-hero-mobile-shop]');
    if (!mobileShop) return;

    const flavorButtons = mobileShop.querySelectorAll('[data-sipit-mobile-flavor]');
    const shopBtn = mobileShop.querySelector('[data-sipit-mobile-onetime]');
    const subscribeBtn = mobileShop.querySelector('[data-sipit-mobile-subscribe]');
    const onetimePrice = mobileShop.querySelector('[data-sipit-mobile-onetime-price]');
    const subscribePrice = mobileShop.querySelector('[data-sipit-mobile-subscribe-price]');
    const pouchImg = mobileShop.querySelector('[data-sipit-mobile-pouch-img]');
    const errorEl = mobileShop.querySelector('[data-sipit-mobile-error]');

    let activeFlavor = flavorButtons[0];

    function refreshMobilePrices() {
      const source = activeFlavor || mobileShop;
      const one = parseFloat(source.dataset.onetime || mobileShop.dataset.onetime || '0');
      const sub = parseFloat(source.dataset.subscribe || mobileShop.dataset.subscribe || '0');
      if (onetimePrice) onetimePrice.textContent = formatMoney(one, moneyFormat);
      if (subscribePrice) subscribePrice.textContent = formatMoney(sub, moneyFormat);
    }

    function selectMobileFlavor(btn) {
      flavorButtons.forEach((item) => {
        item.classList.remove('active');
        item.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      activeFlavor = btn;
      mobileShop.dataset.variantId = btn.dataset.variantId;
      mobileShop.dataset.onetime = btn.dataset.onetime;
      mobileShop.dataset.subscribe = btn.dataset.subscribe;
      const nextSrc = btn.getAttribute('data-image') || btn.dataset.image || '';
      const flavorName = (btn.getAttribute('data-flavor') || btn.textContent || '').trim();
      if (pouchImg && nextSrc) {
        if (pouchImg.getAttribute('src') !== nextSrc) {
          pouchImg.setAttribute('src', nextSrc);
        }
        if (flavorName) {
          pouchImg.alt = 'Sipit Hydration ' + flavorName + ' pouch';
        }
      }
      const media = mobileShop.querySelector('.hero-mobile-card-media');
      if (media) {
        media.classList.toggle('is-strawberry', /strawberry/i.test(flavorName));
        media.classList.toggle('is-watermelon', /watermelon/i.test(flavorName));
      }
      refreshMobilePrices();
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    flavorButtons.forEach((btn) => {
      btn.addEventListener('click', () => selectMobileFlavor(btn));
    });

    const handleMobileClick = async (btn, mode) => {
      if (!btn) return;
      btn.disabled = true;
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      try {
        await addToCart(mobileShop.dataset.variantId, mobileShop.dataset.sellingPlan, mode, {
          redirectToCart: true,
        });
      } catch (error) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = error.message || 'Could not add to cart.';
        }
      } finally {
        btn.disabled = false;
      }
    };

    if (shopBtn) shopBtn.addEventListener('click', () => handleMobileClick(shopBtn, 'onetime'));
    if (subscribeBtn) subscribeBtn.addEventListener('click', () => handleMobileClick(subscribeBtn, 'subscribe'));

    const initialFlavor =
      mobileShop.querySelector('[data-sipit-mobile-flavor].active') || flavorButtons[0];
    if (initialFlavor) {
      selectMobileFlavor(initialFlavor);
    } else {
      refreshMobilePrices();
    }
  }

  roots.forEach((root) => {
    root.querySelectorAll('.reveal').forEach((el, i) => {
      el.style.transitionDelay = (i % 3) * 70 + 'ms';
      io.observe(el);
    });

    const video = root.querySelector('.video-frame video');
    const poster = root.querySelector('.video-frame .poster');
    if (video && poster) {
      video.addEventListener('error', () => {
        poster.style.display = 'block';
      });
      setTimeout(() => {
        if (video.readyState < 2) poster.style.display = 'block';
      }, 1200);
    }

    if (root.matches('[data-sipit-hero-shop]')) {
      initHeroShop(root);
    }
  });
})();
